export default "__VITE_ASSET__aea758c2__"